import {
  Module, ActionTree, MutationTree, GetterTree
} from 'vuex';
import { readCookie, writeCookie, removeCookie } from '@/tools/tools';
import { InvoiceState } from './types';
import { RootState } from '../types';

/**
 * getters
 */
export const getters: GetterTree<InvoiceState, RootState> = {
  invoicelist: (state: InvoiceState) => state.invoicelist
};

/**
 * mutations
 */
export const mutations: MutationTree<InvoiceState> = {
  // 发票列表
  INVOICELIST(state: InvoiceState, payload: []) {
    state.invoicelist = payload;
    writeCookie('invoicelist', state.invoicelist);
  },
  // 编辑发票
  INVOICEEDIT(state: InvoiceState, payload: []) {
    state.invoiceedit = payload;
    writeCookie('invoiceedit', state.invoiceedit);
  },
  // 新增时清空当前编辑地址
  CLEARINVOICE(state: InvoiceState) {
    state.invoiceedit = {};
    writeCookie('invoiceedit', state.invoiceedit);
  },
  // 选择发票
  SELECTINVOICE(state: InvoiceState, payload: {}) {
    state.invoiceselect = payload;
    // writeCookie('invoiceselect', state.invoiceselect);
  },
  // 不开发票清空选择发票
  CLEARSELECTINVOICE(state: InvoiceState) {
    state.invoiceselect = {};
    // writeCookie('invoiceselect', state.invoiceselect);
  },
  // 清空选择发票
  CLEARESELECTINVOICE(state: InvoiceState) {
    state.invoiceselect = {};
  }
};

/**
 * actions
 */
export const actions: ActionTree<InvoiceState, RootState> = {
  setinvoicelist({ commit }, payload: []) {
    commit('INVOICELIST', payload);
  },
  invoiceedit({ commit }, payload: []) {
    commit('INVOICEEDIT', payload);
  },
  clearEditInvoice({ commit }) {
    commit('CLEARINVOICE');
  }
};
/**
 * state
 */
export const state: InvoiceState = {
  invoicelist: readCookie('invoicelist') ? readCookie('invoicelist') : [],
  invoiceedit: readCookie('invoiceedit'),
  invoiceselect: {}
};
const namespaced: boolean = true;

export const invoice: Module<InvoiceState, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
